/**
 * Helper file for initializing the PMW.posterGallery object with common functions used
 * in the sizes-sidebar and poster-gallery files
 */

const searchPageController = 'posters',
    searchPageMethod = 'search',
    localTemplatesController = 'localPosterTemplates',
    categoryController = 'g',
    subcategoryController = 's',
    eventTypesController = 'eventPosterTemplates',
    sizesController = 'sizes',
    recommendationsMethod = 'recommendations',
    postersSizesMethod = 'sizes',
    posterThemesMethod = 'gallery';

export function initPosterGalleryObj() {
    if (typeof PMW.posterGallery === 'undefined') {
        PMW.posterGallery = {};
    }
    PMW.posterGallery.isSearchPage = isSearchPage;
    PMW.posterGallery.isEventTypePage = isEventTypePage;
    PMW.posterGallery.isCategoryPage = isCategoryPage;
    PMW.posterGallery.isSubcategoryPage = isSubcategoryPage;
    PMW.posterGallery.isGalleryPageWithSubfilterCarousel = isGalleryPageWithSubfilterCarousel;
    PMW.posterGallery.isSizesPage = isSizesPage;
    PMW.posterGallery.isDynamicGalleryPage = isDynamicGalleryPage;
    PMW.posterGallery.isGalleryPage = isGalleryPage;
}

/**
 * @param {string} url
 * @return {boolean}
 */
function isDynamicGalleryPage(url = window.location.href) {
    return isSearchPage(url)
        || isEventTypePage(url)
        || isCategoryPage(url)
        || isSubcategoryPage(url)
        || isSizesPage(url)
        || isLocalPosterTemplatesPage(url);
}

/**
 * @param {string} url
 * @return {boolean}
 */
function isSearchPage(url = window.location.href) {
    return (PMW.util.getControllerFromUrl(url) === searchPageController)
        && (PMW.util.getMethodFromUrl(url) === searchPageMethod);
}

/**
 * @param {string} url
 * @return {boolean}
 */
function isGalleryPageWithSubfilterCarousel(url = window.location.href) {
    return isCategoryPage(url) || isSubcategoryPage(url) || isSizesPage(url);
}

/**
 * @param {string} url
 * @return {boolean}
 */
function isCategoryPage(url = window.location.href) {
    return categoryController === PMW.util.getControllerFromUrl(url);
}

/**
 * @param {string} url
 * @return {boolean}
 */
function isSubcategoryPage(url = window.location.href) {
    return subcategoryController === PMW.util.getControllerFromUrl(url);
}

/**
 * @param {string} url
 * @return {boolean}
 */
function isEventTypePage(url = window.location.href) {
    return PMW.util.getControllerFromUrl(url) === eventTypesController;
}

/**
 * @param {string} url
 * @return {boolean}
 */
function isSizesPage(url = window.location.href) {
    return PMW.util.getControllerFromUrl(url) === sizesController;
}

function isRecommendationsGalleryPage(url = window.location.href) {
    return (PMW.util.getControllerFromUrl(url) === searchPageController)
        && (PMW.util.getMethodFromUrl(url) === recommendationsMethod);
}

function isAllSizesPage(url = window.location.href) {
    return (PMW.util.getControllerFromUrl(url) === searchPageController)
        && (PMW.util.getMethodFromUrl(url) === postersSizesMethod);
}

function isPosterThemesPage(url = window.location.href) {
    return (PMW.util.getControllerFromUrl(url) === searchPageController)
        && (PMW.util.getMethodFromUrl(url) === posterThemesMethod);
}

function isLocalPosterTemplatesPage(url = window.location.href) {
    return (PMW.util.getControllerFromUrl(url) === localTemplatesController);
}

function isGalleryPage(url = window.location.href) {
    return isDynamicGalleryPage(url)
        || isRecommendationsGalleryPage(url)
        || isAllSizesPage(url)
        || isPosterThemesPage(url);
}